$(function() {
	$( ".file_to_vr" ).change(function() {
			var folder_id	= 	this.getAttribute("folder")	;
			var file_id		=	this.getAttribute("file")	;
			var vr_id		=	this.getAttribute("vr")		;
			
			var attachment_name			=	this.value					;

			var	path		=	"/vehicle_registerations/" + vr_id +"/file_to_attachment"	;
			var attributes	=	{folder_id: folder_id, file_id: file_id, attachment_name: attachment_name}	;


			$.ajax({	url: 		path,
						type: 		"put",
						data: 		attributes,
						dataType: 	"json", 
						success: 	function(result){	alert("OK");	},
		    			error: 		function (jqXHR, text, errorThrown) {	alert(jqXHR.responseJSON.error);	}
    			});
	});
  
});